<div class="table-header">
  <div>
    <div routerLink="/home" class="back btn"></div>
  </div>
  <div class="selected-users">
    <div
      class="btn"
      [class.remove]="!deleteLoading"
      (click)="deleteUsers()"
      [class.selected]="isUserSelected() && !isMeSelected()"
    >
      <app-loading
        *ngIf="deleteLoading"
        [show]="true"
        [width]="36"
      ></app-loading>
    </div>
    <p *ngIf="isUserSelected()">
      <span>{{ selectedUsers.length }}/{{ users.length }}</span>
      <span>{{ ' selected user(s)' | translate }}</span>
    </p>
    <p *ngIf="!isUserSelected()">
      <span>{{ 'No user is selected' | translate }}</span>
    </p>
  </div>
  <div class="create-user">
    <app-button
      (onClick)="openModal()"
      label="Create user"
      icon="/assets/img/icons/negative/add.svg"
    ></app-button>
  </div>
</div>
<div class="table">
  <app-table
    [entityName]="'user' | translate"
    [loading]="loading"
    [items]="users"
    [columns]="columns"
    [itemsPerPage]="users.length"
    [filter]="filter"
    [clickable]="true"
    (tableItemClickEvent)="rowClicked($event)"
    (onCheckboxClick)="checkboxClicked($event)"
  >
  </app-table>
</div>
<app-modal #modal></app-modal>
<app-modal class="modal-success" [showHeader]="false" #modalSuccess>
  <div class="header">
    <p>{{ 'Account created successfully' | translate }}</p>
    <div (click)="closeModalSuccess()" class="close"></div>
  </div>
  <div class="content">
    <p>
      {{ 'The user' | translate }}
      <span class="bold red">{{
        (this.createdUser && this.createdUser.username) || ''
      }}</span>
      {{ 'has been notified by email' | translate }}. <br /><br />
      {{ 'Their' | translate }}
      <span class="bold">{{ 'temporary password' | translate }}</span>
      {{
        'has been copied to your clipboard and should be shared with the user by the administrator. This password should be stored securely, as it cannot be retrieved later.'
          | translate
      }}
    </p>
    <app-button
      [label]="'Copy password again' | translate"
      (onClick)="copyPassword()"
    ></app-button>
  </div>
</app-modal>
